<template>
  <div rel="textEditing">
    <el-container>
      <el-aside width="40%" class="textEdit-left edit-main">
        <el-input
          type="textarea"
          v-model="htmlToTxt"
          class="htmlTxt"
          :disabled="isEditable"
          @input="handleInput"
        ></el-input>
        <el-button
          type="text"
          size="mini"
          icon="el-icon-download"
          class="exportButton"
          @click="handleExportIn"
        >导出TXT文档</el-button>
        <el-button
          type="text"
          size="mini"
          class="pull-right exportButton"
          @click="handleShowExample"
        >查看编辑示例</el-button>
      </el-aside>
      <el-main @scroll.native="handleScroll" class="textEdit-right edit-main edit-part">
        <div v-for="(item, idx) in survey.pages" :key="idx">
          <div class="txt-title" v-if="idx == 0">{{survey.title}}</div>
          <div class="edit-subtitle" v-if="idx == 0">{{survey.prefix}}</div>
          <div class="page_splitor" v-if="idx !== 0">
            <span>第{{idx}}页</span>
          </div>
          <div
            v-if="item.questions.length > 0"
            v-for="(ques, index) in item.questions"
            :key="index"
          >
            <el-form :model="ques" label-width="80px" class="question-viewer">
              <div v-if="ques.type == 'radio'">
                <radio :ques="ques" :isEditing="false" :item="item" :survey="survey"></radio>
              </div>
              <div v-if="ques.type == 'checkbox'">
                <checkbox :ques="ques" :isEditing="false" :survey="survey"></checkbox>
              </div>
              <div v-if="ques.type == 'textarea'">
                <text-area :ques="ques" :isEditing="false"></text-area>
              </div>
              <div v-if="ques.type == 'star'">
                <star :ques="ques" :isEditing="false"></star>
              </div>
              <div v-if="ques.type == 'matrixRadio'">
                <matrix-radio :isEditing="false" :ques="ques"></matrix-radio>
              </div>
              <div v-if="ques.type == 'matrixCheckbox'">
                <matrix-checkbox :isEditing="false" :ques="ques"></matrix-checkbox>
              </div>
              <div v-if="ques.type == 'matrixStar'">
                <matrix-star :isEditing="false" :ques="ques"></matrix-star>
              </div>
              <div v-if="ques.type == 'select'">
                <wqselect :ques="ques" :isEditing="false"></wqselect>
              </div>
              <div v-if="ques.type == 'sort'">
                <sort :ques="ques" :isEditing="false"></sort>
              </div>
              <div v-if="ques.type == 'description'">
                <description :ques="ques" :isEditing="false"></description>
              </div>
              <div v-if="ques.type == 'upload'">
                <upload :ques="ques" :isEditing="false"></upload>
              </div>
              <div v-if="ques.type == 'chainedSelects'">
                <chained-selects :ques="ques" :isEditing="false"></chained-selects>
              </div>
              <div v-if="ques.type == 'textMultiple'">
                <text-multiple :ques="ques" :isEditing="false"></text-multiple>
              </div>
              <div v-if="ques.type == 'date'">
                <date :ques="ques" :isEditing="false"></date>
              </div>
              <div v-if="ques.type == 'region'">
                <region :ques="ques" :isEditing="false"></region>
              </div>
            </el-form>
          </div>
        </div>
        <p v-if="survey.pages.length === 0">格式错误！请按照规范修改文本内容</p>
      </el-main>
    </el-container>
    <el-dialog title="导出TXT文本" :visible.sync="txtDialogShow" @close="handleTxtDialogClose">
      <el-input type="textarea" :rows="17" v-model="outputToTxt"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="handleExportOut">导出TXT文本</el-button>
      </span>
    </el-dialog>
    <el-dialog title="示例" width="60%" :visible.sync="showExampleDialog" :fullscreen="true">
      <div>
        <textExample></textExample>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showExampleDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import http from "../utils/http";
import { uuid, MSG } from "../utils/utils";
import { DOMAIN } from "../utils/api";
import {
  htmlToTxtMixin,
  messageMixin,
  questionDataSetsMixin
} from "../utils/mixins.js";
import {
  radio,
  checkbox,
  textArea,
  star,
  matrixRadio,
  matrixCheckbox,
  matrixStar,
  wqselect,
  sort,
  description,
  upload,
  chainedSelects,
  textMultiple,
  date,
  region
} from "../components/ques-widget.js";
import textExample from "./textExample.vue";
let timerId = null;
export default {
  name: "textEditing",
  mixins: [htmlToTxtMixin, messageMixin, questionDataSetsMixin],
  components: {
    radio,
    wqselect,
    sort,
    description,
    upload,
    checkbox,
    textArea,
    star,
    matrixRadio,
    matrixCheckbox,
    matrixStar,
    chainedSelects,
    textMultiple,
    textExample,
    date,
    region
  },
  data() {
    return {
      interface: {
        getSurvey: `/survey/get`,
        saveSurvey: `/survey/save`,
        exportTemplateIn: `/survey/exportTemplateIn`,
        exportTemplateOut: `${DOMAIN}/survey/exportTemplateOut`,
        overview: `/stat/overview`,
        clearData: `/stat/clear`
      },
      htmlToTxt: "",
      htmlShow: "",
      survey: {
        pages: []
      },
      tempQuesDataSets: {},
      tempQuesOptSets: {},
      questionsData: [],
      showExampleDialog: false,
      txtDialogShow: false,
      outputToTxt: "",
      surveyId: this.$route.query.id,
      isEditable: false,
      recycleCount: 0
    };
  },
  created() {
    this.handleHtmlToTxt(this.surveyId);
    this.getRecycle();
  },
  methods: {
    mydebounce(func, wait, trailing) {
      return function() {
        let context = this;
        let args = arguments;
        function delay() {
          if (trailing) {
            func.apply(context, args);
          }
          timerId = null;
        }
        if (timerId) {
          clearTimeout(timerId);
        } else if (!trailing) {
          func.apply(context, args);
        }
        timerId = setTimeout(delay, wait || 100);
      };
    },
    handleInput() {
      this.mydebounce(this.handleTextChange, 2000, true)(this.htmlToTxt);
    },
    handleExportIn() {
      this.txtDialogShow = true;
      this.outputToTxt = this.htmlToTxt;
    },
    handleTxtDialogClose() {
      this.outputToTxt = "";
    },
    handleExportOut() {
      let _window = window.open("", "_blank");
      http
        .post(this.interface.exportTemplateIn, {
          surveyId: this.surveyId,
          content: this.htmlToTxt
        })
        .then(({ data }) => {
          let { code, message = "" } = data;
          if (code === 1) {
            _window.location = `${this.interface.exportTemplateOut}?surveyId=${this.surveyId}&surveyName=${this.surveyName}`;
            this.txtDialogShow = false;
            this.outputToTxt = "";
          }
        });
    },
    handleShowExample() {
      this.showExampleDialog = true;
    },
    handleTextChange(val) {
      let arr = val.trim().split(/\n{2,}/);
      this.survey.pages = [];
      this.questionsData = [];
      let pagesIndex = 0;
      let len = 0;
      let descCount = 0;
      let questionKeyTypeMap = new Map();
      questionKeyTypeMap.set("[下拉题]", "select");
      questionKeyTypeMap.set("[排序题]", "sort");
      questionKeyTypeMap.set("[段落说明]", "description");
      questionKeyTypeMap.set("[附件题]", "upload");
      questionKeyTypeMap.set("[单选题]", "radio");
      questionKeyTypeMap.set("[多选题]", "checkbox");
      questionKeyTypeMap.set("[文本题]", "textarea");
      questionKeyTypeMap.set("[打分题]", "star");
      questionKeyTypeMap.set("[矩阵单选题]", "matrixRadio");
      questionKeyTypeMap.set("[矩阵多选题]", "matrixCheckbox");
      questionKeyTypeMap.set("[矩阵打分题]", "matrixStar");
      questionKeyTypeMap.set("[联动题]", "chainedSelects");
      questionKeyTypeMap.set("[填空题]", "textMultiple");
      questionKeyTypeMap.set("[日期题]", "date");
      questionKeyTypeMap.set("[区域题]", "region");
      for (let i = 0; i < arr.length; i++) {
        let tempArr = [];
        if (arr[i].trim() === "====分页====") {
          if (this.survey.pages[pagesIndex]) {
            this.survey.pages[pagesIndex].questions = this.deepClone(
              this.questionsData
            );
          } else {
            this.survey.pages.push({
              id: uuid(),
              index: pagesIndex,
              questions: this.deepClone(this.questionsData)
            });
          }
          this.questionsData = [];
          pagesIndex++;
        } else {
          tempArr = arr[i].split("\n");
        }
        if (i === 0) {
          if (tempArr[0]) {
            this.survey.title = tempArr.join("");
          } else {
            this.showError("请输入问卷标题", 3000);
            return;
          }
          continue;
        } else if (i === 1) {
          this.survey.prefix = tempArr.join("");
        } else {
          let type = "";
          if (tempArr[0]) {
            let matArr = tempArr[0].trim().match(/\[(.+)\]/g);
            if (matArr) {
              type = matArr[0];
            }
          }
          let idx = tempArr[0] ? tempArr[0].indexOf("[") : -1;
          if (type && !questionKeyTypeMap.has(type)) {
            this.showError("请填写正确的题目类型", 3000);
            return;
          } else if (idx === 0) {
            this.showError("题目不能为空", 3000);
            return;
          } else if (idx != -1) {
            let nowType = questionKeyTypeMap.get(type);
            if (!nowType) {
              this.showError("题目类型填写不完整", 3000);
              return;
            }
            if (nowType === "description") {
              descCount++;
            }
            this.addQuestionData(
              nowType,
              tempArr[0].substr(0, idx),
              i - 2 - pagesIndex - descCount
            );
            this.questionsData.push(this.tempQuesDataSets);
            this.tempQuesDataSets = {};
            len = this.questionsData.length - 1;
            let remarks = tempArr[0].match(/\((.+)\)/g);
            if (remarks) {
              this.questionsData[len].description = remarks[0].slice(1, -1);
            }
            if (nowType === "chainedSelects") {
              let optionsArr = tempArr.slice(1);
              try {
                let _arr = optionsArr.map(function(a, b) {
                  return {
                    lineNumber: b + 1,
                    lineContent: a
                  };
                });
                let obj = {},
                  out = [];
                let isError = this.tree2json(_arr, obj);
                if (isError) return;
                this.arr2obj(obj.groups, out);
                this.questionsData[len].groups = this.deepClone(out);
                obj.levels.forEach(val => {
                  this.questionsData[len].levels.push({
                    value: val
                  });
                });
              } catch (error) {
                this.showError("题目、分页之间请用换行分割", 3000);
                return;
              }
            } else if (
              nowType === "matrixCheckbox" ||
              nowType === "matrixRadio"
            ) {
              if (tempArr[1]) {
                this.questionsData[len].options = tempArr[1]
                  .trim()
                  .split(" ")
                  .map(item => {
                    return {
                      text: item,
                      checked: "",
                      id: uuid()
                    };
                  });
              } else {
                this.showError("请正确填写选项", 3000);
                return;
              }
              for (let j = 2; j < tempArr.length; j++) {
                try {
                  if (tempArr[j]) {
                    this.questionsData[len].subTitles.push({
                      id: uuid(),
                      text: tempArr[j],
                      checked: []
                    });
                  }
                } catch (error) {
                  this.showError("题目、分页之间请用换行分割", 3000);
                }
              }
            } else if (nowType === "star" || nowType === "matrixStar") {
              let num = [];
              if (tempArr[1]) {
                num = tempArr[1]
                  .trim()
                  .split("~")
                  .map(item => {
                    return parseInt(item);
                  });
                this.questionsData[len].starBeginNum =
                  num[0] > num[1] ? num[1] : num[0];
                this.questionsData[len].starNum =
                  num[0] > num[1] ? num[0] - num[1] + 1 : num[1] - num[0] + 1;
                this.questionsData[len].revertSort = num[0] > num[1];
              } else {
                this.showError("请正确填写选项", 3000);
                return;
              }
              for (let j = 2; j < tempArr.length; j++) {
                try {
                  if (tempArr[j]) {
                    this.questionsData[len].subTitles.push({
                      id: uuid(),
                      text: tempArr[j],
                      checkedStar: num[0] > num[1] ? num[1] : num[0]
                    });
                  }
                } catch (error) {
                  this.showError("题目、分页之间请用换行分割", 3000);
                  return;
                }
              }
            } else {
              for (let k = 1; k < tempArr.length; k++) {
                try {
                  if (tempArr[k]) {
                    this.addQuestionOpt(nowType, tempArr[k].trim());
                    this.questionsData[len].options.push(this.tempQuesOptSets);
                  }
                } catch (error) {
                  this.showError("题目、分页之间请用换行分割", 3000);
                  return;
                }
              }
            }
          }
        }
      }
      if (this.survey.pages[pagesIndex]) {
        this.survey.pages[pagesIndex].questions = this.deepClone(
          this.questionsData
        );
      } else {
        this.survey.pages.push({
          id: uuid(),
          index: pagesIndex,
          questions: this.deepClone(this.questionsData)
        });
      }
      this.questionsData = [];
      this.saveSurveyAfterTxt();
    },
    saveSurveyAfterTxt() {
      http
        .post(this.interface.saveSurvey, {
          surveyId: this.surveyId,
          surveyJson: JSON.stringify(this.survey)
        })
        .then(({ data }) => {
          let { code, message } = data;
          if (code === 1) {
            this.survey.surveyVersion = data.data;
            window.sessionStorage.setItem("surveyVersion", data.data);
            this.showSuccess("保存成功");
          } else {
            this.showError(message);
          }
        })
        .catch(error => {
          this.showError(error);
        });
    },
    recursionInitGroups(groups) {},
    addQuestionData(type, title, index) {
      let id = uuid();
      switch (type) {
        case "select":
          this.initTempQuesDataSets(
            this.questionDataSets.selectNewQues,
            id,
            title,
            index
          );
          break;
        case "sort":
          this.initTempQuesDataSets(
            this.questionDataSets.sortNewQues,
            id,
            title,
            index
          );
          break;
        case "radio":
          this.initTempQuesDataSets(
            this.questionDataSets.radioNewQues,
            id,
            title,
            index
          );
          break;
        case "checkbox":
          this.initTempQuesDataSets(
            this.questionDataSets.checkboxNewQues,
            id,
            title,
            index
          );
          break;
        case "textMultiple":
          this.initTempQuesDataSets(
            this.questionDataSets.textMultipleNewQues,
            id,
            title,
            index
          );
          break;
        case "chainedSelects":
          this.initTempQuesDataSets(
            this.questionDataSets.chainedSelectsNewQues,
            id,
            title,
            index
          );
          break;
        case "matrixCheckbox":
          this.initTempQuesDataSets(
            this.questionDataSets.matrixCheckboxNewQues,
            id,
            title,
            index
          );
          break;
        case "matrixRadio":
          this.initTempQuesDataSets(
            this.questionDataSets.matrixRadionNewQues,
            id,
            title,
            index
          );
          break;
        case "star":
          this.initTempQuesDataSets(
            this.questionDataSets.starNewQues,
            id,
            title,
            index
          );
          break;
        case "matrixStar":
          this.initTempQuesDataSets(
            this.questionDataSets.matrixStarNewQues,
            id,
            title,
            index
          );
          break;
        case "upload":
          this.initTempQuesDataSets(
            this.questionDataSets.uploadNewQues,
            id,
            title,
            index
          );
          break;
        case "description":
          this.initTempQuesDataSets(
            this.questionDataSets.descriptionNewQues,
            id,
            title,
            index
          );
          break;
        case "textarea":
          this.initTempQuesDataSets(
            this.questionDataSets.textareaNewQues,
            id,
            title,
            index
          );
          break;
        case "date":
          this.initTempQuesDataSets(
            this.questionDataSets.dateNewQues,
            id,
            title,
            index
          );
          break;
        case "region":
          this.initTempQuesDataSets(
            this.questionDataSets.regionNewQues,
            id,
            title,
            index
          );
          break;
      }
    },
    initTempQuesDataSets(initData, id, title, index) {
      this.tempQuesDataSets = {
        ...this.deepClone(initData),
        id,
        title,
        index: index,
        realIndex: index
      };
    },
    addQuestionOpt(type, text) {
      let id = uuid();
      switch (type) {
        case "select":
          this.tempQuesOptSets = {
            ...this.deepClone(this.questionTypeOptSets.selectNewOpts),
            id,
            text
          };
          break;
        case "sort":
          this.tempQuesOptSets = {
            ...this.deepClone(this.questionTypeOptSets.sortNewOpts),
            id,
            text
          };
          break;
        case "radio":
          this.tempQuesOptSets = {
            ...this.deepClone(this.questionTypeOptSets.radioNewOpts),
            id,
            text
          };
          break;
        case "checkbox":
          this.tempQuesOptSets = {
            ...this.deepClone(this.questionTypeOptSets.checkboxNewOpts),
            id,
            text
          };
          break;
      }
    },
    handleScroll(e) {
      let _scale =
        document.getElementsByClassName("el-textarea__inner")[0].scrollHeight /
        e.target.scrollHeight;
      document.getElementsByClassName(
        "el-textarea__inner"
      )[0].scrollTop = parseInt(e.target.scrollTop * _scale);
    },
    warningTips() {
      if (this.recycleCount > 0) {
        this.isEditable = true;
        this.$confirm(
          "该问卷已有" +
            this.recycleCount +
            "份回收数据，文本编辑会导致所有统计结果丢失，是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          http
            .get(this.interface.clearData, {
              surveyId: this.surveyId
            })
            .then(response => {
              const { code, data, message } = response;
              if (code === 1) {
                this.isEditable = false;
              } else {
                MSG.error(message);
              }
            })
            .catch(error => {
              MSG.error(error);
            });
        });
      }
    },
    getRecycle() {
      http
        .get(this.interface.overview, {
          surveyId: this.surveyId
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.recycleCount = data.recycleCount;
            this.warningTips();
          }
        });
    }
  }
};
</script>
<style lang="scss">
div[rel="textEditing"] {
  .textEdit-left,
  .textEdit-right {
    border: 1px solid #eaeaea;
    height: calc(100vh - 121px);
  }
  .htmlTxt .el-textarea__inner {
    height: calc(100vh - 151px);
    line-height: 36px;
  }
  .textEdit-left {
    border-right: 4px solid #eaeaea;
  }
  .textEdit-right {
    border-left: 4px solid #eaeaea;
  }
  .page_splitor {
    font-size: 14px;
    padding: 20px 0;
    text-align: center;
    position: relative;
    &:before {
      content: "";
      border: 1px solid #e6e6e6;
      position: absolute;
      margin-top: 10px;
      left: 0;
      right: 0;
    }
    span {
      color: #999;
      background: #fff;
      padding: 0 20px;
      position: relative;
      z-index: 1;
    }
  }
  .txt-title {
    text-align: center;
    font-size: 24px;
    padding: 0;
  }
  .exportButton {
    color: #ff552e;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .left20 {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/textEditing.vue